<script>
  // import axios from '../../axios'
  import { Bar } from 'vue-chartjs'

  export default {
    props: ['labels', 'data', 'tooltips'],
    extends: Bar,
    mounted () {
      this.loadGraphData()
    },
    watch: {
      data (newVal) {
        this.loadGraphData(newVal)

      }
    },
    data () {
      return {
        datacollection: {

          labels: [],
          datasets: [
            {
              label: '',
              backgroundColor: 'rgba(0, 175, 239, 0.5)',
              borderColor: '#006fc0',
              borderWidth: 1,
              data: []
            }
          ]
        },

        options: {
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true
              },
              gridLines: {
                display: true
              }
            }],
            xAxes: [{
              gridLines: {
                display: false
              }
            }]
          },
          legend: {
            display: false
          },

          responsive: true,
          maintainAspectRatio: false,

          tooltips: {
            enabled: this.tooltips,
            mode: 'single',
            callbacks: {
              label: (tooltipItems, data) => {
                return '₪' + this.tooltips[tooltipItems.index]
              }
            }
          },
        }
      }
    },
    methods: {
      loadGraphData (newVal = false) {
        this.datacollection.labels = this.labels
        this.datacollection.datasets[0].data = newVal ? newVal : this.data
        // for (let i in obj) {
        //   this.datacollection.labels.push(this.$t('months.' + i))
        //   this.datacollection.datasets[0].data.push(obj[i])
        // }
        this.renderChart(this.datacollection, this.options)
      }
    }
    // async mounted () {
    //   axios.get('/dashboard/products')
    //     .then((res) => {
    //       let obj = res.data.data.rows
    //
    //       for (let i in obj) {
    //
    //         this.datacollection.labels.push(i)
    //         this.datacollection.datasets[0].data.push(obj[i])
    //       }
    //
    //       this.renderChart(this.datacollection, this.options)
    //     })
    //     .catch((err) => {
    //       this.$emit('alert', 'danger', err.response.data.status)
    //     })
    //
    // }
  }
</script>








